import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 登录验证
export default new Vuex.Store({
  state: {
    approvalCunt: 0,
    // 全局加载
    overAllLoading: {
      status: false,
      info: ''
    },
    // 水印参数
    watermarkParameters: {
      color: '#CCCCCC',
      fontSize: 16,
      axisY: 100,
      axisX: 15,
      width: '450',
      height: '200'
    },
    // 畜只种类 - 当前
    currentLivestock: localStorage.getItem('CURRENT_LIVESTOCK_INDEX')
      ? Number(localStorage.getItem('CURRENT_LIVESTOCK_INDEX')).toString()
      : '',
    livestockListStoreData: localStorage.getItem('LIVESTOCK_LIST_STORE_DATA')
      ? JSON.parse(localStorage.getItem('LIVESTOCK_LIST_STORE_DATA'))
      : []
  },
  mutations: {
    // 金融助贷 菜单左侧 储存值
    changeCunt(state, cunt) {
      state.approvalCunt = cunt;
    },
    overAllLoadingChange(state, val) {
      state.overAllLoading = val;
    },
    mutCurrentLivestock(state, val) {
      state.currentLivestock = val;
      localStorage.setItem('CURRENT_LIVESTOCK_INDEX', val);
    },
    mutLivestockListStroe(state, val) {
      state.livestockListStoreData = val || [];
      localStorage.setItem('LIVESTOCK_LIST_STORE_DATA', JSON.stringify(val));
    }
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js